export default "/images/vendor/flag-icons/flags/1x1/pt.svg?56a4f662dcecf23ceaaf4ef12c9307a4";